import { render, staticRenderFns } from "./AcoesWidget.vue?vue&type=template&id=4d568eea&scoped=true"
import script from "./AcoesWidget.vue?vue&type=script&lang=js"
export * from "./AcoesWidget.vue?vue&type=script&lang=js"
import style0 from "./AcoesWidget.vue?vue&type=style&index=0&id=4d568eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d568eea",
  null
  
)

export default component.exports